import { serviceMaker, methods, api } from "@/http/index.js";

export const getUserData = () => serviceMaker(`/users`, methods.GET, api.NGB);
export const deleteUserData = (id) =>
  serviceMaker(`/users/${id}`, methods.DELETE, api.NGB);
export const getUserTemplate = () =>
  serviceMaker(`/users/template`, methods.GET, api.NGB);
export const createUser = (data) =>
  serviceMaker(`/users`, methods.POST, api.NGB, data);
export const editUserData = (id) =>
  serviceMaker(`/users/${id}?template=true`, methods.GET, api.NGB);
export const editRole = (id, data) =>
  serviceMaker(`/users/${id}`, methods.PUT, api.NGB, data);
export const getviewUser = (id) =>
  serviceMaker(`/users/${id}`, methods.GET, api.NGB);
